function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";
import { Single, Multiple } from "./common";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'select-input';

/**
 * This is the component description.
 */
const SelectInput = ({
  id,
  className: userClassName,
  style,
  name,
  label,
  labelColor,
  color,
  options,
  hasDefault,
  validate,
  optional,
  description,
  disabled,
  isLoading,
  autoComplete,
  placeholder,
  getTagColor,
  multiple,
  ...otherProps
}) => {
  const inputProps = {
    name,
    label,
    labelColor,
    color,
    options,
    hasDefault,
    validate,
    optional,
    description,
    disabled,
    isLoading,
    placeholder,
    getTagColor,
    autoComplete
  };
  const Input = multiple ? Multiple : Single;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, otherProps)));
};
SelectInput.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The name of the select input
   */
  name: PropTypes.string,
  /**
   * The label of the select input
   */
  label: PropTypes.string,
  /**
   * The input field validator function
   */
  validate: PropTypes.func,
  /**
   * The select input description
   */
  description: PropTypes.string,
  /**
   * The options of the select input
   */
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool
  })])),
  /**
   * Whether the select input should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * The color of the select input
   */
  color: PropTypes.string,
  /**
   * The color of the select input label
   */
  labelColor: PropTypes.string,
  /*
  * Whether the query that is fetching the select options is still in flight
  */
  isLoading: PropTypes.bool,
  /**
   * The autoComplete value that the browser should watch for the input
   */
  autoComplete: PropTypes.string,
  /**
  * Whether the input is optional or not
  */
  optional: PropTypes.bool,
  /**
   * Whether the select input should allow multiple selections
   */
  multiple: PropTypes.bool,
  /**
   * The placeholder of the select input
   */
  placeholder: PropTypes.string,
  /**
   * Whether this select input has a default value(s)
   */
  hasDefault: PropTypes.bool
};
SelectInput.defaultProps = {
  disabled: false,
  multiple: false,
  hasDefault: false
};
export default /*#__PURE__*/memo(SelectInput);